<template>
  <div
    :class="`notification center-v notification--${type} ${(fullWidth && 'full-width') || ''} ${noMargin? 'no-margin' : ''} ${classes || ''}`"
  >
    <div :class="`inline-flex center-v ${fullWidth ? 'container' : ''}`">
      <tr-svg-icon
        v-if="!hideIcon"
        classes="block pull-left"
        :name="type === 'info' ? 'ic-info' : 'ic-warning-black'"
        :color="type === 'warning' ? 'grey-semi-dark' : 'white'"
      />
      <span :class="`block pull-left vertical-align-super ${hideIcon ? '' : 'margin-left'}`">
        <slot />
      </span>
    </div>

    <tr-svg-icon
      v-if="closeButton"
      :on-button-click="onClose"
      classes="block pull-right cursor-pointer"
      name="ic-close"
      color="grey-semi-dark"
    />
  </div>
</template>

<script>
import TrSvgIcon from './TrSvgIcon.vue';

export default {
  name: 'TrAlertNotification',
  components: {
    TrSvgIcon
  },
  props: ['fullWidth', 'type', 'hideIcon', 'classes', 'noMargin', 'closeButton'],
  emits: ['close'],
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.notification--info {
  background-color: #0096ed;
  border-color: #ffffff;
  color: #ffffff;
}

.notification--success {
  background-color: #1fbfae;
  border-color: #ffffff;
  color: #ffffff;
}
</style>
